var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "kpi" }, [
    _c("span", [
      _c("h2", [_vm._v(_vm._s(_vm.data))]),
      _vm._v("\n    " + _vm._s(_vm.units) + "\n  "),
    ]),
    _vm._v(" "),
    _vm.icon ? _c("i", { class: _vm.icon }) : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }